import { dateToMysql, dateToShow } from '@/helpers/dates'
import { map, isEmpty, isNull, find } from 'lodash'
import { mapGetters } from 'vuex'

const prepareShow = price => {
  price.validity = dateToShow(price.validity)

  return price
}

const prepareShowCovenant = covenant => {
  covenant.validity = dateToShow(covenant.validity)

  return covenant
}

const prepareSaveCovenant = covenant => {
  return {
    covenant_id: covenant.covenant_id,
    value: covenant.value
  }
}

export default {
  ...mapGetters(['userIsCompany']),
  setProfessional (professional) {
    this.professional_id = professional.professional_id
  },
  newPrice () {
    this.price.id = null
    this.price.validity = null
  },
  afterPrepareShow () {
    this.$http.get('v1/professional/companies/covenants')
      .then(({data}) => {
        const covenants = map(data, covenant => {
          return {
            name: covenant.name,
            covenant_id: covenant.covenant_id,
            value: null
          }
        })

        this.covenants = map(covenants, covenant => {
          const current = find(this.price.covenants, {covenant_id: covenant.covenant_id})
          if (current) {
            return {...covenant, ...prepareShowCovenant(current)}
          }
          return covenant
        })
      })
  },
  prepareSave (price) {
    price.validity = dateToMysql(price.validity)
    if (!this.userIsCompany) {
      price.professional_id = this.professional_id
    }
    price.covenants = map(this.covenants, prepareSaveCovenant)

    return price
  },
  prepareShow,
  afterSave (price) {
    this.saved = true
  },

  changeValue (value) {
    this.covenants = map(this.covenants, covenant => {
      if (isNull(covenant.value) || isEmpty(covenant.value)) {
        covenant.value = value
      }

      return covenant
    })
  },
  changeValidity (validity) {
    this.covenants = map(this.covenants, covenant => {
      if (isNull(covenant.validity) || isEmpty(covenant.validity)) {
        covenant.validity = validity
      }

      return covenant
    })
  },
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/methods.js